import { render, staticRenderFns } from "./button-group.vue?vue&type=template&id=ebc889d8&scoped=true&"
import script from "./button-group.vue?vue&type=script&lang=js&"
export * from "./button-group.vue?vue&type=script&lang=js&"
import style0 from "./button-group.vue?vue&type=style&index=0&id=ebc889d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc889d8",
  null
  
)

export default component.exports